import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover", "list", "count"]
  static values = {
    cardId: Number,
    toggleUrl: String
  }

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.handleOtherPopoverOpen = this.handleOtherPopoverOpen.bind(this)
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('popover:open', this.handleOtherPopoverOpen)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('popover:open', this.handleOtherPopoverOpen)
  }

  handleOtherPopoverOpen(event) {
    if (event.detail.controller !== this) {
      this.close()
    }
  }

  handleClickOutside(event) {
    if (this.hasPopoverTarget && !this.element.contains(event.target)) {
      this.close()
    }
  }

  toggle(event) {
    event.stopPropagation()
    if (this.hasPopoverTarget) {
      const wasHidden = this.popoverTarget.classList.contains('hidden')
      this.popoverTarget.classList.toggle('hidden')
      if (wasHidden) {
        document.dispatchEvent(new CustomEvent('popover:open', { detail: { controller: this } }))
      }
    }
  }

  close() {
    if (this.hasPopoverTarget) {
      this.popoverTarget.classList.add('hidden')
    }
  }

  async toggleEmoticonClick(event) {
    event.preventDefault()
    const button = event.currentTarget
    const emoticonId = button.dataset.emoticonId
    const success = await this.toggleEmoticon(emoticonId)

    if (success) {
      if (button.classList.contains('bg-emerald-500')) {
        button.classList.remove('bg-emerald-500', 'hover:bg-emerald-600', 'text-white')
        button.classList.add('bg-gray-100', 'hover:bg-gray-200', 'text-gray-700')
      } else {
        button.classList.remove('bg-gray-100', 'hover:bg-gray-200', 'text-gray-700')
        button.classList.add('bg-emerald-500', 'hover:bg-emerald-600', 'text-white')
      }
    }
  }

  async toggleEmoticon(emoticonId) {
    try {
      const response = await fetch(this.toggleUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: JSON.stringify({ emoticon_id: emoticonId })
      })

      if (response.ok) {
        const data = await response.json()
        if (this.hasCountTarget) {
          this.countTarget.textContent = data.count > 0 ? data.count : ''
        }
        return true
      }
      return false
    } catch (err) {
      console.error('Failed to toggle emoticon:', err)
      return false
    }
  }
}
